import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUnlockAlt, faUser, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { Form, Alert, InputGroup, FormCheck } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import AkasbLogo from "../../assets/img/logo_akasb.png";

const Signup = () => {
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmarPassword, setConfirmarPassword] = useState("");
    const [erro, setErro] = useState("");
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const API_BASE_URL= process.env.REACT_APP_API_BASE_URL;

    const handleRegister = async (e) => {
        e.preventDefault();
        setErro("");

        const API_BASE_URL_AUTH_REGISTER= `${API_BASE_URL}/auth/register`;

        if (password !== confirmarPassword) { setErro("As palavras-passe não coincidem."); return; }
        setLoading(true);
        try {
            const response = await fetch(API_BASE_URL_AUTH_REGISTER, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Email: email, Password: password, Nome: nome })
            });
            if (!response.ok) {
                const msg = await response.text();
                throw new Error(msg || "Erro no registo.");
            }
            history.push("/connect/login");
        } catch (err) {
            setErro(err.message);
        } finally { setLoading(false); }
    };

    const inputStyle = { border: "1.5px solid #e9ecef", height: 50, fontSize: 15, background: "#f8f9fa" };
    const prefixStyle = { background: "#f8f9fa", border: "1.5px solid #e9ecef", borderRight: "none" };

    return (
        <main style={{ minHeight: "100vh", background: "linear-gradient(135deg, #1e1d45 0%, #2d2c6b 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px 20px" }}>
            <div style={{ width: "100%", maxWidth: 440 }}>
                {/* Logo */}
                <div style={{ textAlign: "center", marginBottom: 28 }}>
                    <div style={{ width: 60, height: 60, borderRadius: "50%", background: "#E4B428", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
                        <img src={AkasbLogo} alt="AKASB" style={{ width: 40 }} />
                    </div>
                    <div style={{ color: "white", fontSize: 20, fontWeight: 900, letterSpacing: 2, fontFamily: "'Anton', sans-serif" }}>AKASB</div>
                    <div style={{ color: "rgba(255,255,255,0.45)", fontSize: 13, marginTop: 4 }}>Junta-te à nossa equipa</div>
                </div>

                {/* Card */}
                <div style={{ background: "white", borderRadius: 20, padding: "36px 32px", boxShadow: "0 24px 60px rgba(0,0,0,0.3)" }}>
                    <h2 style={{ fontWeight: 800, fontSize: 22, color: "#1e1d45", marginBottom: 4 }}>Criar Conta</h2>
                    <p style={{ color: "#9ca3af", fontSize: 14, marginBottom: 28 }}>Preencha os dados para se registar</p>

                    {erro && <Alert variant="danger" style={{ borderRadius: 12, fontSize: 14 }}>{erro}</Alert>}

                    <Form onSubmit={handleRegister}>
                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>Nome Completo</Form.Label>
                            <InputGroup>
                                <InputGroup.Text style={prefixStyle}><FontAwesomeIcon icon={faUser} style={{ color: "#9ca3af" }} /></InputGroup.Text>
                                <Form.Control required type="text" placeholder="Nome e apelido" value={nome} onChange={e => setNome(e.target.value)} style={{ ...inputStyle, borderLeft: "none" }} />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>Email</Form.Label>
                            <InputGroup>
                                <InputGroup.Text style={prefixStyle}><FontAwesomeIcon icon={faEnvelope} style={{ color: "#9ca3af" }} /></InputGroup.Text>
                                <Form.Control required type="email" placeholder="exemplo@email.pt" value={email} onChange={e => setEmail(e.target.value)} style={{ ...inputStyle, borderLeft: "none" }} />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>Password</Form.Label>
                            <InputGroup>
                                <InputGroup.Text style={prefixStyle}><FontAwesomeIcon icon={faUnlockAlt} style={{ color: "#9ca3af" }} /></InputGroup.Text>
                                <Form.Control required type="password" placeholder="Mínimo 6 caracteres" value={password} onChange={e => setPassword(e.target.value)} style={{ ...inputStyle, borderLeft: "none" }} />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>Confirmar Password</Form.Label>
                            <InputGroup>
                                <InputGroup.Text style={prefixStyle}><FontAwesomeIcon icon={faUnlockAlt} style={{ color: "#9ca3af" }} /></InputGroup.Text>
                                <Form.Control required type="password" placeholder="Repita a palavra-passe" value={confirmarPassword} onChange={e => setConfirmarPassword(e.target.value)} style={{ ...inputStyle, borderLeft: "none" }} />
                            </InputGroup>
                        </Form.Group>

                        <div style={{ display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 24, padding: "14px", background: "#f8f9fa", borderRadius: 10 }}>
                            <FormCheck.Input required id="terms" style={{ width: 18, height: 18, cursor: "pointer", marginTop: 2, flexShrink: 0 }} />
                            <label htmlFor="terms" style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.5, cursor: "pointer" }}>
                                Garanto que sou maior de idade e quero inscrever-me, ou ao meu educando, e aceito receber comunicações SMS.
                            </label>
                        </div>

                        <button type="submit" disabled={loading} style={{ width: "100%", height: 50, background: loading ? "#6b7280" : "#E4B428", border: "none", borderRadius: 12, color: "#1e1d45", fontWeight: 800, fontSize: 15, cursor: loading ? "not-allowed" : "pointer" }}>
                            {loading ? "A criar conta..." : "Criar Conta"}
                        </button>
                    </Form>

                    <div style={{ textAlign: "center", marginTop: 24, fontSize: 14, color: "#9ca3af" }}>
                        Já tem uma conta?{" "}
                        <Link to="/connect/login" style={{ color: "#1e1d45", fontWeight: 700, textDecoration: "none" }}>Fazer login</Link>
                    </div>
                </div>

                <div style={{ textAlign: "center", marginTop: 24 }}>
                    <Link to="/" style={{ color: "rgba(255,255,255,0.45)", fontSize: 13, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <FontAwesomeIcon icon={faAngleLeft} /> Voltar à página inicial
                    </Link>
                </div>
            </div>
        </main>
    );
};

export default Signup;
